import { render, staticRenderFns } from "./noticeBanner.vue?vue&type=template&id=36f5504a&scoped=true&"
import script from "./noticeBanner.vue?vue&type=script&lang=js&"
export * from "./noticeBanner.vue?vue&type=script&lang=js&"
import style0 from "./noticeBanner.vue?vue&type=style&index=0&id=36f5504a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f5504a",
  null
  
)

export default component.exports